import React, { useState } from "react";
import CatalogoSimple from "../components/CatalogoSimple";
import GestionarProveedores from "../components/GestionarProveedores";
import GestionarCategoriasProveedor from "../components/GestionarCategoriasProveedor";
import VisibilidadCategorias from "../components/VisibilidadCategorias";
import GestionarTipoCambio from "../components/GestionarTipoCambio";
import { Ayuda } from "../context/AyudaContext";

const TABS = [
  { valor: "areas", texto: "Áreas", icono: "🏢", soloAdmin: true },
  { valor: "edificios", texto: "Edificios", icono: "🏗️", soloAdmin: true },
  { valor: "proveedores", texto: "Proveedores", icono: "🚚", soloAdmin: false },
  { valor: "categorias", texto: "Categorías", icono: "🏷️", soloAdmin: true },
  { valor: "tipo_cambio", texto: "Tipo de cambio", icono: "💱", soloAdmin: false },
];

function GestionarCatalogos() {
  const usuario = JSON.parse(localStorage.getItem("usuario") || "null");
  const esAdmin = usuario?.rol === "administrador";

  // Áreas y Edificios son catálogos de configuración institucional — exclusivos
  // de Administrador. Compras solo gestiona Proveedores desde aquí.
  const [tab, setTab] = useState(esAdmin ? "areas" : "proveedores");
  const tabsVisibles = TABS.filter((t) => esAdmin || !t.soloAdmin);

  return (
    <div>
      <h2 style={{ margin: 0, color: "var(--tema-titulo, #0b3c60)", textAlign: "center" }}>🗃️ Gestionar Catálogos</h2>
      <Ayuda>
        <p style={{ color: "#5b6472", marginTop: "0.25rem", textAlign: "center" }}>
          Datos base que usa el resto del sistema: áreas, edificios, proveedores y tipo de cambio.
        </p>
      </Ayuda>

      <div style={styles.pills}>
        {tabsVisibles.map((t) => (
          <button
            key={t.valor}
            type="button"
            onClick={() => setTab(t.valor)}
            style={{ ...styles.pill, ...(tab === t.valor ? styles.pillActivo : {}) }}
          >
            {t.icono} {t.texto}
          </button>
        ))}
      </div>

      {esAdmin && tab === "areas" && (
        <CatalogoSimple
          titulo="Áreas Solicitantes"
          icono="🏢"
          color="var(--tema-primario, #2f6690)"
          bg="var(--tema-suave, #dceaf5)"
          endpoint="/api/areas"
          placeholder="Ej. Informática"
        />
      )}
      {esAdmin && tab === "edificios" && (
        <CatalogoSimple
          titulo="Edificios"
          icono="🏗️"
          color="#3d5a99"
          bg="#e1e7f5"
          endpoint="/api/edificios"
          placeholder="Ej. Berlín"
        />
      )}
      {tab === "proveedores" && <GestionarProveedores />}
      {tab === "tipo_cambio" && <GestionarTipoCambio />}
      {esAdmin && tab === "categorias" && (
        <>
          <GestionarCategoriasProveedor />
          <VisibilidadCategorias />
        </>
      )}
    </div>
  );
}

const styles = {
  pills: {
    display: "flex",
    gap: "0.5rem",
    justifyContent: "center",
    flexWrap: "wrap",
    margin: "1.25rem 0 1.5rem",
  },
  pill: {
    border: "1px solid #d3d9df",
    background: "#fff",
    color: "#5b6472",
    borderRadius: 999,
    padding: "0.5rem 1.1rem",
    fontSize: "0.85rem",
    fontWeight: 600,
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  pillActivo: {
    background: "var(--tema-titulo, #0b3c60)",
    borderColor: "var(--tema-titulo, #0b3c60)",
    color: "#fff",
  },
};

export default GestionarCatalogos;
